<template>
  <div
    class="inline-flex items-center gap-1 rounded-sm bg-gray-500 p-2 text-white"
  >
    <span class="text-sm font-semibold">
      {{ $t('category.brand.exclusive') }}
    </span>
    <IconDiamond class="relative -top-1" />
  </div>
</template>
